import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { container } from '@/app/container';
import { CatalogRepositoryToken } from '../../di/tokens';

export function useRoles(page = 1, perPage = 10, includeDeprecated = false) {
  const repository = container.resolve(CatalogRepositoryToken);
  return useQuery({
    queryKey: ['catalog', 'roles', page, perPage, includeDeprecated],
    queryFn: () => repository.listRoles({ page, perPage, includeDeprecated }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}

/**
 * ⚠️ Tirar um scope **revoga** os grants de quem está nele — o back publica o
 * evento e o delivery consome. Não é uma edição cosmética.
 */
export function useUpdateRoleScopes(roleId: string) {
  const queryClient = useQueryClient();
  const repository = container.resolve(CatalogRepositoryToken);
  return useMutation({
    mutationFn: (scopeIds: string[]) =>
      repository.updateRoleScopes(roleId, { scopeIds }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['catalog', 'roles'] });
    },
  });
}
